// npm
import DatePicker, { registerLocale } from 'react-datepicker';
import ko from 'date-fns/locale/ko';
import { BiSearch } from 'react-icons/bi';
import { RiFileExcel2Line } from 'react-icons/ri';
import styled from 'styled-components';

// atomic component
import Container from 'components/UI/atoms/Container';
import Text from 'components/UI/atoms/Text';
import Grid from 'components/UI/atoms/Grid';
import Button from 'components/UI/atoms/Button';
import TextField from 'components/UI/atoms/TextField';
import Table from 'components/UI/atoms/Table';
import Select from 'components/UI/atoms/Select';
import Pagination from 'components/UI/molecules/Pagination';

// common
import { WAKEUP_FORM_DATA } from 'common/common.constatns';
import { IUseForm } from 'common/interface/form';
import { WakeUp } from 'common/interface/props';

registerLocale('ko', ko);

interface IProps {
  useForm: IUseForm;
  onSubmit: () => void;
  solType: WakeUp;
  state: {
    startDate: Date;
    endDate: Date;
    jobData: {
      startDate: string;
      allEndDate: string;
      scrapShopCode: string;
      scrapShopName: string;
      scrapShopId: string;
      state: string;
      scrapType: string;
      msg: string;
      jobId: number;
      email: string;
      wakeupId: string;
      wakeupEtc5: string;
      successCount?: number;
      failureCount?: number;
    }[];
    nowPage: number;
    max: number;
  };
  setState: {
    setStartDate: any;
    setEndDate: any;
    setNowPage: any;
  };
  jobDetailEvent: (type: 'VIEW' | 'EXCEL', jobId: number, count: number) => void;
}

const ButtonTag = styled(Button)`
  border: 1px solid #e2e2e2;
  padding: 5px 5px;

  display: inline-flex;
  justify-content: center;
  align-items: center;
  :hover {
    background: #f5f5f5;
  }
`;

export default function Dashboard({ useForm, onSubmit, solType, state, setState, jobDetailEvent }: IProps) {
  return (
    <Container>
      {/* <Grid top={30} bottom={10}>
        <Text fontSize="1.4rem" fontWeight={600} color="#444">
          PLAYAPI 연동관리
        </Text>
        <Link to={statisticsPath}>통계</Link>|<Link to={dashboardPath}>상세조회</Link>
      </Grid>
      <Line color="#e8e8e8" /> */}
      {solType === 'COUPANG' && (
        <Grid top={15}>
          ※ 성공/실패 집계의 경우 쿠팡에 데이터를 전달하기까지의 집계이며, <br />
          실제 쿠팡 Wing 상품등록 성공 / 실패 여부 및 사유 는 돋보기/엑셀 다운로드를 통해 자세히 확인하실 수 있습니다.
        </Grid>
      )}
      <form onSubmit={useForm.handleSubmit(onSubmit)}>
        <Grid display="flex" alignItems="center" top={20} bottom={20}>
          <Grid display="inline-flex" justifyContent="flex-start" alignItems="center" >
            <DatePicker
              locale="ko"
              selected={state.startDate}
              onChange={(targetDate: Date) => {
                setState.setStartDate(targetDate);
              }}
              dateFormat="yyyy-MM-dd"
              customInput={<TextField variant="outlined" width={100} style={{ fontSize: '0.88rem' }} />}
            />
            &nbsp;~&nbsp;
            <DatePicker
              locale="ko"
              selected={state.endDate}
              onChange={(targetDate: Date) => {
                setState.setEndDate(targetDate);
              }}
              dateFormat="yyyy-MM-dd"
              customInput={<TextField variant="outlined" width={100} style={{ fontSize: '0.88rem' }} />}
            />
          </Grid>
          {/* <Select variant="outlined" {...useForm.register(`wakeUpType`)}>
            {WAKEUP.map((one, index) => {
              if (one === 'WEMAKEPRICE')
                return (
                  <option value={one} key={index}>
                    {one}
                  </option>
                );
            })}
          </Select> */}
          <Grid display="flex" justifyContent="flex-end">
            <Select variant="outlined" {...useForm.register(`searchType`)} style={{ fontSize: '0.88rem' }}>
              <option value="playautoId">플레이오토 ID</option>
              {/* <option value="marketId">가져오는 쇼핑몰 ID</option> */}
              <option value="jobId">작업번호</option>
              {solType === 'COUPANG' ? (
                <option value="coupangVendorId">쿠팡 업체코드</option>
              ) : (
                <option value="wemakepriceId">{WAKEUP_FORM_DATA[solType].name.type1} 아이디</option>
              )}
            </Select>
            &nbsp;
            <TextField
              type="text"
              placeholder="조회 할 내용"
              variant="outlined"
              {...useForm.register(`searchValue`, { maxLength: 50 })}
              style={{ fontSize: '0.88rem' }}
            />
            &nbsp;
            <Button color="main" width={80} size="small" borderRadius={5}>
              검색
            </Button>
          </Grid>
        </Grid>
      </form>
      <Grid>
        <Table
          headerItems={[
            {
              width: 170,
              headerName: '작업날짜',
              align: 'center',
              headerAlign: 'center',
              editable: true,
            },
            {
              width: 150,
              headerName: '플레이오토ID',
              align: 'center',
              headerAlign: 'center',
              editable: true,
            },
            {
              width: 100,
              headerName: '위메프ID',
              align: 'center',
              headerAlign: 'center',
              editable: true,
              hide: solType === 'WEMAKEPRICE' ? false : true,
            },
            {
              width: 100,
              headerName: '쿠팡업체코드',
              align: 'center',
              headerAlign: 'center',
              editable: true,
              hide: solType === 'COUPANG' ? false : true,
            },
            {
              width: 120,
              headerName: '가져오는 쇼핑몰',
              align: 'center',
              headerAlign: 'center',
              editable: true,
            },
            {
              width: 120,
              headerName: '작업상태',
              align: 'center',
              headerAlign: 'center',
              editable: true,
            },
            {
              width: 140,
              headerName: '작업메세지',
              align: 'center',
              headerAlign: 'center',
              editable: true,
            },
            {
              width: 110,
              headerName: '성공 / 실패',
              align: 'center',
              headerAlign: 'center',
              editable: true,
            },
            {
              width: 110,
              headerName: '작업번호',
              align: 'center',
              headerAlign: 'center',
              renderCell: (params: any) => {
                return (
                  <Grid>
                    <Text fontSize="0.77rem" fontWeight={500} lineHeight={24}>
                      {params.value.jobId}
                    </Text>
                    <Grid display="flex" justifyContent="center">
                      <ButtonTag
                        color="white"
                        size="small"
                        variant="outlined"
                        width={40}
                        borderRadius={5}
                        onClick={() => {
                          jobDetailEvent('VIEW', params.value.jobId, (params.value.successCount || 0) + (params.value.failureCount || 0));
                        }}
                      >
                        <BiSearch size="0.77rem" />
                      </ButtonTag>
                      <ButtonTag
                        color="white"
                        size="small"
                        variant="outlined"
                        width={40}
                        borderRadius={5}
                        onClick={() => {
                          jobDetailEvent('EXCEL', params.value.jobId, (params.value.successCount || 0) + (params.value.failureCount || 0));
                        }}
                      >
                        <RiFileExcel2Line size="0.77rem" />
                      </ButtonTag>
                    </Grid>
                  </Grid>
                );
              },
            },
            {
              width: 100,
              headerName: '지정상품',
              align: 'center',
              headerAlign: 'center',
              editable: true,
            },
          ]}
          bodyItems={state.jobData.map((one) => [
            one.startDate,
            one.email,
            one.wakeupId,
            one.wakeupEtc5,
            one.scrapShopName,
            one.state,
            one.msg,
            `${one.successCount || 0} / ${one.failureCount || 0}`,
            {
              jobId: one.jobId,
              successCount: one.successCount,
              failureCount: one.failureCount,
            },
            one.scrapType,
            // <>
            //   <Text fontSize="0.9rem" fontWeight={500}>
            //     {one.job_id}
            //   </Text>
            //   <Grid display="flex" justifyContent="center">
            //     <ButtonTag
            //       color="white"
            //       size="small"
            //       variant="outlined"
            //       width={40}
            //       borderRadius={5}
            //       onClick={() => {
            //         jobDetailEvent('VIEW', one.job_id, (one.successCount || 0) + (one.failureCount || 0));
            //       }}
            //     >
            //       <BiSearch />
            //     </ButtonTag>
            //     <ButtonTag
            //       color="white"
            //       size="small"
            //       variant="outlined"
            //       width={40}
            //       borderRadius={5}
            //       onClick={() => {
            //         jobDetailEvent('EXCEL', one.job_id, (one.successCount || 0) + (one.failureCount || 0));
            //       }}
            //     >
            //       <RiFileExcel2Line />
            //     </ButtonTag>
            //   </Grid>
            // </>,
          ])}
        />
        <Grid top={30} />
        <Pagination nowPage={state.nowPage} max={state.max} size={5} nowPageEvent={setState.setNowPage} />
      </Grid>
    </Container>
  );
}
